<div [formGroup]="passwordForm" class="app-password-input-container">
	<input
		(input)="_handleInput()"
		[type]="showPassword ? 'text' : 'password'"
		class="app-password-input-element"
		formControlName="password"
		id="password"
	/>
	<mat-icon
		(mousedown)="togglePassword(showPassword)"
		(mouseup)="togglePassword(showPassword)"
		class="primary-light-color"
		matSuffix
		>visibility
	</mat-icon>
</div>
